/**
 * EquipmentMenuHandler.js - 装备菜单逻辑（槽位 + 底部背包装备）
 */
import EquipmentSystem from './EquipmentSystem.js';
import EquipmentMenuUI from './EquipmentMenuUI.js';

export default class EquipmentMenuHandler {
    constructor(scene, menuUI, equipmentMenuUI) {
        this.scene = scene;
        this.menuUI = menuUI;
        this.equipmentMenuUI = equipmentMenuUI;
    }

    /**
     * 获取某槽位可装备的背包物品
     */
    getEquipableItems(slot, playerData) {
        return (playerData.inventory || []).filter((item) => {
            if (!item) return false;
            let itemSlot = item.slot || EquipmentSystem.getSlotFromType(item.type);
            if (itemSlot) itemSlot = EquipmentSystem.normalizeSlot(itemSlot);
            return itemSlot === slot && EquipmentSystem.canEquip(item, playerData);
        });
    }

    /**
     * 空格：已装备则卸下，未装备则穿上底部选中的物品
     */
    handleSlotAction(slotIndex, inventoryIndex, playerData, onUpdate) {
        const slot = EquipmentSystem.SLOT_ORDER[slotIndex];
        if (!slot) return;

        const equipped = EquipmentSystem.getEquippedItem(playerData, slot);

        if (equipped) {
            this.unequipItem(slot, playerData, onUpdate);
            return;
        }

        const items = this.getEquipableItems(slot, playerData);
        if (items.length === 0) {
            this.menuUI.showMessage('背包中没有可装备的道具', '#ffaa00');
            return;
        }

        const safeIndex = Phaser.Math.Clamp(inventoryIndex, 0, items.length - 1);
        this.equipItem(items[safeIndex], playerData, onUpdate);
    }

    equipItem(item, playerData, onUpdate) {
        const result = EquipmentSystem.equipItem(item, playerData);

        if (result.success) {
            EquipmentSystem.removeFromInventory(item, playerData.inventory);
            if (result.oldEquipment) {
                EquipmentSystem.addToInventory(result.oldEquipment, playerData.inventory);
            }
            this.menuUI.showMessage(result.message, '#00ff00');
            if (onUpdate) {
                this.scene.time.delayedCall(300, onUpdate);
            }
        } else {
            this.menuUI.showMessage(result.message, '#ff0000');
        }
    }

    unequipItem(slot, playerData, onUpdate) {
        const result = EquipmentSystem.unequipItem(playerData, slot);

        if (result.success) {
            EquipmentSystem.addToInventory(result.item, playerData.inventory);
            this.menuUI.showMessage(result.message, '#00ff00');
            if (onUpdate) {
                this.scene.time.delayedCall(300, onUpdate);
            }
        } else {
            this.menuUI.showMessage(result.message, '#ff0000');
        }
    }

    /**
     * 方向键切换装备槽
     */
    navigateSlot(currentIndex, direction) {
        return EquipmentMenuUI.getAdjacentSlotIndex(currentIndex, direction);
    }

    /**
     * Q/E 切换底部背包装备索引
     */
    navigateInventory(currentIndex, delta, slotIndex, playerData) {
        const slot = EquipmentSystem.SLOT_ORDER[slotIndex];
        const items = this.getEquipableItems(slot, playerData);
        if (items.length === 0) return 0;
        return Phaser.Math.Wrap(currentIndex + delta, 0, items.length);
    }

    isSubMenuActive() {
        return false;
    }

    destroy() {}
}
